import { Plugin } from './Plugin';
import { EntityPlugin } from './EntityPlugin';
import { ScenePlugin } from './ScenePlugin';
import { PCFSoftShadowMap, Vector3 } from 'three';
import { CSM } from 'three/examples/jsm/csm/CSM.js';
import { CSMHelper } from 'three/examples/jsm/csm/CSMHelper.js';

export class CSMShadowsPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.dependencies.add(EntityPlugin);
		this.dependencies.add(ScenePlugin);

		const renderer = this.viewer.rendering.renderer;

		renderer.shadowMap.enabled = true;
		renderer.shadowMap.type = PCFSoftShadowMap;

		this.csm = new CSM( {
			maxFar: 1000,
			cascades: 4,
			mode: 'practical',
			parent: this.viewer.rendering.scene,
			shadowMapSize: 1024,
			lightNear:0.01,
			lightFar:200,
			lightMargin:0,
			lightDirection: new Vector3(-1, -1, -1 ).normalize(),
			camera: this.viewer.rendering.camera
		});

	}

	attach(){
		this.manager.get(EntityPlugin).on('entity-added', this.onEntityAdded);
		this.manager.get(EntityPlugin).on('entity-removed', this.onEntityRemoved);
		this.manager.get(ScenePlugin).on('scene-changed', this.onSceneUpdate);
		this.manager.get(ScenePlugin).on('scene-updated', this.onSceneUpdate);
		window.addEventListener('resize', this.resize);
		this.viewer.rendering.ticker.on('tick', this.render);
	}

	detach(){
		this.manager.get(EntityPlugin).off('entity-added', this.onEntityAdded);
		this.manager.get(EntityPlugin).off('entity-removed', this.onEntityRemoved);
		this.manager.get(ScenePlugin).off('scene-changed', this.onSceneUpdate);
		this.manager.get(ScenePlugin).off('scene-updated', this.onSceneUpdate);
		window.removeEventListener('resize', this.resize);
		this.viewer.rendering.ticker.off('tick', this.render);
	}

	resize = () => {
		this.csm.updateFrustums();
	}

	render = () => {
		this.csm.update();
	}

	onSceneUpdate = (scene) => {
		scene.traverse((obj) => {
			obj.receiveShadow = true;
		})
	}

	onEntityAdded = (entity) => {
		const setup = (e) => {
			e.traverse((obj) => {
				obj.receiveShadow = true;
				obj.castShadow = true;
				if(obj.isMesh){
					this.csm.setupMaterial(obj.material);
				}
			})
		};

		if(entity.loaded) setup(entity);
		else entity.addEventListener('loaded', () => {
			setup(entity);
		})
	}

	onEntityRemoved = (entity) => {
		entity.traverse((obj) => {
			if(obj.isMesh){
				this.clearMaterial(obj.material);
			}
		})
	}


	clearMaterial(material){
		const shader = this.csm.shaders.get(material);

		delete material.onBeforeCompile;
		delete material.defines.USE_CSM;
		delete material.defines.CSM_CASCADES;
		delete material.defines.CSM_FADE;

		if ( shader !== null ) {

			delete shader.uniforms.CSM_cascades;
			delete shader.uniforms.cameraNear;
			delete shader.uniforms.shadowFar;

		}

		material.needsUpdate = true;

		this.csm.shaders.delete(material);
	}

}